document.getElementsByTagName("html")[0].style.visibility = "hidden";

jQuery(function ($) {
  $('html').removeClass('no-js').addClass('js');
});

$(window).bind('beforeunload', function() {
      $('#loader-wrapper').css('display', 'block');
      var rani=TweenLite.to($('.loader-section.section-full'),0.6,{left:0, opacity:1,ease:Power3.easeOut});
});

$(document).ready(function() {

      document.getElementsByTagName("html")[0].style.visibility = "visible";

      // number of loaded images for preloader progress
      var loadedCount = 0; //current number of images loaded
      var imagesToLoad = $('.section').length; //number of slides with .bcg container
      var loadingProgress = 0; //timeline progress - starts at 0


              if (!$("body").hasClass("home"))
              {

              tn1 = TweenMax.to([div1], 1, {bezier:{curviness:1.5, values:[
              {x:30, y:30}, {x:0, y:60}, {x:-30, y:30}, {x:0, y:0}]},
              ease:Linear.easeNone, paused:false, repeat:-1});

              tn2 = TweenMax.to([div2], 1, {bezier:{curviness:1.5, values:[
              {x:30, y:30}, {x:0, y:60}, {x:-30, y:30}, {x:0, y:0}]},
              ease:Linear.easeNone, paused:false, delay:0.25,repeat:-1});

              tn3 = TweenMax.to([div3], 1, {bezier:{curviness:1.5, values:[
              {x:30, y:30}, {x:0, y:60}, {x:-30, y:30}, {x:0, y:0}]},
              ease:Linear.easeNone, paused:false, delay:0.5,repeat:-1});

              tn4 = TweenMax.to([div4], 1, {bezier:{curviness:1.5, values:[
              {x:30, y:30}, {x:0, y:60}, {x:-30, y:30}, {x:0, y:0}]},
              ease:Linear.easeNone, paused:false, delay:0.75,repeat:-1});

              }


    $('.section').imagesLoaded({
        background: true
    }).always( function( instance )
      {
        setTimeout(loadComplete,  2000);
    }).progress( function( instance, image )
      {
        //one more image has been loaded
        loadedCount++;
        loadingProgress = (loadedCount/imagesToLoad);
        var result = image.isLoaded ? 'loaded' : 'broken';
        //console.log( 'image is ' + result + ' for ' + image.img.src );
    });






    function loadComplete()
    {


      if (!$("body").hasClass("home"))
      {
        //var x = $(".logo-linka").position();
        //var y = $(".k").position();
        //var tleft= x.left - y.left +70;
        //var ttop= x.top - y.top -230;
        var wwidth= - $( window ).width();
        //console.log(tleft +" " + ttop)
        var divani= TweenLite.to($('.div1'),0.2,{opacity:0, width:0});
        var kani=TweenLite.to($('#k'),0.5,{ width:0, opacity:0, ease:Power3.easeOut});
        var rani=TweenLite.to($('.loader-section.section-full'),0.6,{left:wwidth, opacity:0.9,ease:Power3.easeOut});
        rani.eventCallback("onComplete", rideau);

      }
      else
      {

        //var x = $(".logo-linka").position();
        //var y = $(".logo").position();
        //var tleft= x.left - y.left +70;
        //var ttop= x.top - y.top -230;
        //var wwidth= - $( window ).width();
        //var kani=TweenLite.to($('#logointro'),0.5,{ width:0, opacity:0,ease:Power3.easeOut});
        //var rani=TweenLite.to($('.loader-section.section-full'),0.6,{left:wwidth, opacity:0.9,ease:Power3.easeOut});
        //rani.eventCallback("onComplete", rideau);



      }
    }


    $('#loader-wrapper').click(function () {

      var wwidth= - $( window ).width();
      var kani=TweenLite.to($('#logointro'),0.5,{ width:0, opacity:0,ease:Power3.easeOut});
      var eani=TweenLite.to($('#entrerintro'),0.5,{ width:0, opacity:0,ease:Power3.easeOut});
      var lani=TweenLite.to($('#cityintro'),0.5,{ width:0, opacity:0,ease:Power3.easeOut});
      var rani=TweenLite.to($('.loader-section.section-full'),0.6,{left:wwidth, opacity:0.9,ease:Power3.easeOut});
      rani.eventCallback("onComplete", rideau);

    });


    function rideau()
    {
      $('body').addClass('loaded');
      $('#loader-wrapper').css('display', 'none');
      TweenMax.pauseAll(true);
    }

      /*
    setTimeout(function(){
        $('body').addClass('loaded');
    },  6000);
    */



      //console.log( $('#fullpage').hasClass( "listingapp" ));

      $('#fullpage').fullpage({
            css3: true,

            navigation: !$('#fullpage').hasClass( "listingapp" ),
            navigationPosition: 'right',
            controlArrows: false,

            afterLoad: function(anchorLink, index)
            {
		            var loadedSection = $(this);

                console.log(index);

            		//using index
            		if(index > 2){
                  $( "#gotop").show();

            			//alert("Section 1 ended loading");
            		}
                else {

                  $( "#gotop" ).hide();

                }


	          },
            onLeave: function(index, nextIndex, direction)
            {
        		var leavingSection = $(this);


        		//after leaving section 2
        		if(index == 1 && direction =='down'){
               //$( "#gotop").show();
        			//alert("Going leaving section 1!");
        		}

        		else if(nextIndex == 3 && direction == 'up')
            {
        			// $( "#gotop" ).hide();
        		}
        	},
          onSlideLeave: function( anchorLink, index, slideIndex, direction, nextSlideIndex)
          {
      		var leavingSlide = $(this);

      		//leaving the first slide of the 2nd Section to the right
      		if(direction == 'right')
          {
              $( ".up" ).hide();
              $( ".left" ).show();

      		}

      		//leaving the 3rd slide of the 2nd Section to the left
      		if(direction == 'left')
          {
            $( ".up" ).show();
            $( ".left" ).hide();

      		}
      	  }


      });



        $('.hamburger').click(function () {

              $('#wrapper').toggleClass('toggled2');

        });

        $('#sidebar-wrapper').mouseover(function () {
            if($('.hamburger').css('display') == 'none')
            {
              $('#wrapper').toggleClass('toggled');
            }
        });
        $('#sidebar-wrapper').mouseout(function () {
          if($('.hamburger').css('display') == 'none')
          {
              $('#wrapper').toggleClass('toggled');
          }
        });

        $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function()
        {
		        $(this).toggleClass('open');
	      });

});
